import { render, staticRenderFns } from "./RelatedListing.vue?vue&type=template&id=6e84a563&scoped=true"
import script from "./RelatedListing.vue?vue&type=script&lang=js"
export * from "./RelatedListing.vue?vue&type=script&lang=js"
import style0 from "./RelatedListing.vue?vue&type=style&index=0&id=6e84a563&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e84a563",
  null
  
)

export default component.exports